var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.99992H3.5C2.96957 3.99992 2.46086 4.21063 2.08579 4.5857C1.71071 4.96078 1.5 5.46948 1.5 5.99992V16.9999C1.5 17.5304 1.71071 18.0391 2.08579 18.4141C2.46086 18.7892 2.96957 18.9999 3.5 18.9999H14.5C15.0304 18.9999 15.5391 18.7892 15.9142 18.4141C16.2893 18.0391 16.5 17.5304 16.5 16.9999V11.9999M15.086 2.58592C15.2705 2.3949 15.4912 2.24253 15.7352 2.13772C15.9792 2.0329 16.2416 1.97772 16.5072 1.97542C16.7728 1.97311 17.0361 2.02371 17.2819 2.12427C17.5277 2.22484 17.751 2.37334 17.9388 2.56113C18.1266 2.74891 18.2751 2.97222 18.3756 3.21801C18.4762 3.4638 18.5268 3.72716 18.5245 3.99272C18.5222 4.25828 18.467 4.52072 18.3622 4.76473C18.2574 5.00874 18.105 5.22942 17.914 5.41392L9.328 13.9999H6.5V11.1719L15.086 2.58592Z",
    stroke: "#2E65F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/images/edit_icon.8c8544c153f502bfe9fbdc6dfbbfcf1d.svg";
export { ForwardRef as ReactComponent };